import React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    color?: string;
    size?: number;
}

export const LockIconBig = (props: Props) => {
    const size = props.size ?? 24;
    const color = props.color ?? resolveColor("--theme-primary");

    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.7625 20L5.28535 19.9972C4.53633 19.9972 4 19.4102 4 18.7465L4.00175 11.4105C4.00175 10.7025 4.62053 10.1764 5.36385 10.1784L5.78441 10.1796L5.79098 7.53499C5.79449 6.05795 6.49396 4.73301 7.60083 3.70097C8.77917 2.60238 10.3057 2.00446 11.9893 2.00003C13.6658 1.99559 15.1893 2.581 16.3733 3.66386C17.5297 4.72131 18.2257 6.09143 18.2292 7.61567L18.2345 10.1788L18.6708 10.1796C19.3053 10.1808 19.9965 10.6407 19.9969 11.2935L20 18.8635C20 19.4795 19.4295 19.9511 18.7625 20ZM15.5598 10.1804L15.5576 7.53539C15.5094 6.77245 15.2011 6.08982 14.6398 5.54071C13.2799 4.13832 10.9201 4.09152 9.48346 5.43138C8.84013 6.03091 8.45728 6.79667 8.45641 7.65521L8.45334 10.1824L15.5598 10.1804Z"
                fill={color}
            />
        </svg>
    );
};
